module.exports = __webpack_public_path__ + "static/healthcare-chair-0979aa1e13aee591188824f51bc35c63.jpg";